import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ToastContainer } from 'react-toastify'
// import 'bootstrap/dist/css/bootstrap.min.css';


if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  //  <React.StrictMode>
   <>
    <App />
    <ToastContainer/>
    </>
  // </React.StrictMode> 
)

reportWebVitals();
